import { Navigate } from 'react-router-dom';

import { useShell } from '../shell/use-shell.js';
import { NoGameEmptyState } from '../shell/empty-states/no-game-empty-state.js';

export function StudioRootPage(): JSX.Element {
  const { activeStudio, games, loading } = useShell();
  if (loading) return <></>;

  const firstGame = games[0];
  if (firstGame !== undefined) {
    return <Navigate to={`/s/${activeStudio.shortId}/g/${firstGame.shortId}/overview`} replace />;
  }

  return <NoGameEmptyState />;
}
